<template>
  <div class="page-content_wrapper project-detail">
    <div class="project-title">{{ detail.title }}</div>
    <div class="project-info">
      <div class="project-time">{{ detail.createTime }}</div>
    </div>
    <div class="project-content">
      <cell-group class="project-base_container" title="项目基本信息">
        <cell label="项目名称">{{ detail.title }}</cell>
        <cell label="项目内容">{{ detail.text }}</cell>
      </cell-group>
      <cell-group class="project-image_wrapper" title="项目详情图">
        <el-row :gutter="10">
          <el-col
            v-for="(item, index) in detail.picDetails"
            :key="index"
            :span="8"
          >
            <img class="project-image" :src="item">
          </el-col>
        </el-row>
      </cell-group>
    </div>
    <el-button class="return-button" @click="$router.back()">返回</el-button>
  </div>
</template>

<script>
import CellGroup from '@/components/CellGroup'
import Cell from '@/components/Cell'
import { fetchProjectDetail } from '@/api'

export default {

  components: {
    CellGroup,
    Cell
  },
  data() {
    return {
      detail: ''
    }
  },

  mounted() {
    this.fetchDetail(this.$route.query.id)
  },

  methods: {
    fetchDetail(id) {
      fetchProjectDetail({
        id
      })
        .then(res => {
          res.data.picDetails = res.data.picDetails ? res.data.picDetails.split(';') : []

          this.detail = res.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.project-detail {
    padding-top: 41px;
    padding-bottom: 41px;
    .project-title {
        font-size: 26px;
        line-height: 40px;
        font-weight: bold;
    }
    .project-info {
        display: flex;
        align-items: center;
        color: #999;
        padding: 15px 0;
        border-bottom: 1px solid #F0F0F0;
        margin: 23px 0 0;
        .project-time {
            line-height: 20px;
            padding: 0 0 0 20px;
            background-image: url('~@/assets/images/icon-clock.png');
            background-repeat: no-repeat;
            background-position: center left;
        }
    }
    /deep/ .project-content {
        margin: 46px 0;
        .cell-group-title {
            border-color: #417EF7;
        }
        .cell-group-container {
            padding-left: 0;
            padding-right: 17px;
            .cell-label {
                color: #333;
                text-align: right;
            }
            .cell-content {
                color: #666;
                margin: 0 0 0 25px;
            }
        }
        .project-base_container {
            .cell-content {
                color: #808080;
            }
        }
        .project-image_wrapper {
            .cell-group-container {
                padding: 25px 0 0;
            }
            .project-image {
                width: 100%;
                height: 250px;
                border-radius: 10px;
                margin: 20px 0 0;
            }
        }
    }
    .return-button {
        display: block;
        width: 240px;
        height: 44px;
        font-size: 16px;
        color: #417EF7;
        border-color: currentColor;
        background-color: #fff;
        margin: 0 auto;
    }
}
</style>
